/**
 * Featured video — sections/video.liquid
 * <featured-video> is a custom element; lifecycle replaces DOM scans + shopify:section:load hooks.
 */
(function () {
  'use strict';

  if (typeof customElements === 'undefined' || customElements.get('featured-video')) {
    return;
  }

  function supportsHtml5Video() {
    var v = document.createElement('video');
    return typeof v.canPlayType === 'function' && !!v.canPlayType;
  }

  /** Matches sections/video.liquid — data-featured-video-* on <featured-video class="featured-video"> */
  var ATTR = {
    poster: 'data-featured-video-poster-image',
    autoplay: 'data-featured-video-autoplay',
    autoloop: 'data-featured-video-autoloop',
    captionOnPlay: 'data-featured-video-display-text-over-video',
    embedId: 'data-featured-video-video-src',
    aspect: 'data-featured-video-aspect-ratio',
    provider: 'data-featured-video-provider',
    mp4: 'data-featured-video-video-mp4',
    playable: 'data-featured-video-has-playable-video',
    play: 'data-featured-video-play',
    iframeTitle: 'data-featured-video-iframe-title'
  };

  function readPoster(root) {
    var p = root.getAttribute(ATTR.poster);
    if (!p || p === 'false') return false;
    return p;
  }

  function readSettings(root) {
    var parts = (root.getAttribute(ATTR.aspect) || '16:9').split(':');
    return {
      root: root,
      posterImage: readPoster(root),
      autoPlay: root.getAttribute(ATTR.autoplay) === 'true',
      loop: root.getAttribute(ATTR.autoloop) === 'true',
      showCaptionOnPlay: root.getAttribute(ATTR.captionOnPlay) === 'true',
      embedId: (root.getAttribute(ATTR.embedId) || '').trim(),
      aspectW: parseFloat(parts[0]) || 16,
      aspectH: parseFloat(parts[1]) || 9,
      provider: (root.getAttribute(ATTR.provider) || 'youtube').toLowerCase(),
      mp4: (root.getAttribute(ATTR.mp4) || '').trim(),
      hasPlayable: root.getAttribute(ATTR.playable) === 'true',
      iframeTitle: (root.getAttribute(ATTR.iframeTitle) || '').trim() || 'Video'
    };
  }

  function shouldAutoload(s) {
    if (!s.hasPlayable) return false;
    var w = window.innerWidth || document.documentElement.clientWidth || 0;
    var noPoster = s.posterImage === false;
    if (noPoster && w <= 798) return true;
    if (noPoster) return true;
    if (s.autoPlay) return true;
    return false;
  }

  function wrapMedia(mediaEl) {
    var outer = document.createElement('div');
    outer.className = 'featured-video__embed';
    var inner = document.createElement('div');
    inner.className = 'featured-video__embed-inner';
    inner.appendChild(mediaEl);
    outer.appendChild(inner);
    return outer;
  }

  function buildYoutubeIframe(s, userInitiated) {
    if (!s.embedId) return null;
    var autoplay;
    var muted;
    if (userInitiated) {
      autoplay = 1;
      muted = 0;
    } else if (s.posterImage === false && !s.autoPlay) {
      autoplay = 0;
      muted = 0;
    } else if (s.autoPlay) {
      autoplay = 1;
      muted = 1;
    } else {
      autoplay = 1;
      muted = 0;
    }
    var loop = s.loop ? 1 : 0;
    var playlist = s.loop ? '&playlist=' + encodeURIComponent(s.embedId) : '';
    var src =
      'https://www.youtube.com/embed/' +
      encodeURIComponent(s.embedId) +
      '?autoplay=' +
      autoplay +
      '&mute=' +
      muted +
      '&loop=' +
      loop +
      playlist +
      '&controls=1&rel=0&modestbranding=1&playsinline=1&enablejsapi=1';
    var iframe = document.createElement('iframe');
    iframe.src = src;
    iframe.setAttribute('width', String(Math.round(s.aspectW * 100)));
    iframe.setAttribute('height', String(Math.round(s.aspectH * 100)));
    iframe.setAttribute(
      'allow',
      'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
    );
    iframe.setAttribute('allowfullscreen', '');
    iframe.setAttribute('loading', 'eager');
    iframe.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
    iframe.title = s.iframeTitle;
    iframe.style.border = '0';
    if (!userInitiated && s.autoPlay) {
      iframe.setAttribute('fetchpriority', 'high');
    }
    return wrapMedia(iframe);
  }

  function buildVimeoIframe(s, userInitiated) {
    if (!s.embedId) return null;
    var autoplay;
    var muted;
    if (userInitiated) {
      autoplay = 1;
      muted = 0;
    } else if (s.posterImage === false && !s.autoPlay) {
      autoplay = 0;
      muted = 0;
    } else if (s.autoPlay) {
      autoplay = 1;
      muted = 1;
    } else {
      autoplay = 1;
      muted = 0;
    }
    var loop = s.loop ? 1 : 0;
    var src =
      'https://player.vimeo.com/video/' +
      encodeURIComponent(s.embedId) +
      '?loop=' +
      loop +
      '&title=0&byline=0&portrait=0&autoplay=' +
      autoplay +
      '&muted=' +
      muted +
      '&playsinline=1';
    var iframe = document.createElement('iframe');
    iframe.src = src;
    iframe.setAttribute('width', String(Math.round(s.aspectW * 100)));
    iframe.setAttribute('height', String(Math.round(s.aspectH * 100)));
    iframe.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture');
    iframe.setAttribute('allowfullscreen', '');
    iframe.setAttribute('loading', 'eager');
    iframe.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
    iframe.title = s.iframeTitle;
    iframe.style.border = '0';
    if (!userInitiated && s.autoPlay) {
      iframe.setAttribute('fetchpriority', 'high');
    }
    return wrapMedia(iframe);
  }

  function buildHtml5Video(s, userInitiated) {
    if (!s.mp4) return null;
    if (!supportsHtml5Video()) return null;

    var video = document.createElement('video');
    video.className = 'featured-video__html5';
    video.title = s.iframeTitle;
    video.controls = true;
    video.playsInline = true;
    video.setAttribute('preload', 'metadata');

    if (s.posterImage && s.posterImage !== false) {
      var p = String(s.posterImage);
      var posterUrl = /^https?:\/\//i.test(p) || /^\/\//.test(p) ? (/^\/\//.test(p) ? 'https:' + p : p) : 'https://' + p;
      video.poster = posterUrl;
    }

    if (s.loop) {
      video.loop = true;
    }

    if (userInitiated) {
      video.autoplay = true;
    } else if (s.autoPlay) {
      video.autoplay = true;
      video.muted = true;
    }

    var mp4 = document.createElement('source');
    mp4.src = s.mp4;
    mp4.type = 'video/mp4';
    video.appendChild(mp4);

    return wrapMedia(video);
  }

  function buildEmbed(s, userInitiated) {
    if (s.provider === 'youtube') return buildYoutubeIframe(s, userInitiated);
    if (s.provider === 'vimeo') return buildVimeoIframe(s, userInitiated);
    if (s.provider === 'html5') return buildHtml5Video(s, userInitiated);
    return null;
  }

  function hidePlayControls(root) {
    root.querySelectorAll('[' + ATTR.play + ']').forEach(function (el) {
      el.classList.add('featured-video__play--hidden');
    });
  }

  function appendFrame(root, s, userInitiated) {
    if (root.querySelector('.featured-video__embed')) return;

    var node = buildEmbed(s, userInitiated);
    if (!node) return;

    if (!s.showCaptionOnPlay) {
      var cap = root.querySelector('.featured-video__media .caption');
      if (cap) {
        cap.style.display = 'none';
      }
    }

    hidePlayControls(root);

    root.classList.add('featured-video--embed-active');
    root.style.aspectRatio = String(s.aspectW) + ' / ' + String(s.aspectH);

    root.appendChild(node);

    var media = root.querySelector('.featured-video__media');
    if (media) {
      Array.prototype.forEach.call(media.children, function (ch) {
        if (!ch.classList.contains('caption')) {
          ch.style.display = 'none';
        }
      });
    }
  }

  class FeaturedVideoElement extends HTMLElement {
    connectedCallback() {
      var root = this;

      if (root.getAttribute('data-fv-ready') === '1') {
        return;
      }
      root.setAttribute('data-fv-ready', '1');

      root._fvOnClick = function (ev) {
        var play = ev.target.closest('[' + ATTR.play + ']');
        if (!play || !root.contains(play)) return;
        ev.preventDefault();
        var s = readSettings(root);
        if (!s.hasPlayable) return;
        appendFrame(root, s, true);
      };

      root._fvOnKeydown = function (ev) {
        if (ev.key !== 'Enter' && ev.key !== ' ') return;
        var play = ev.target.closest('[' + ATTR.play + ']');
        if (!play || !root.contains(play)) return;
        if (play.getAttribute('tabindex') !== '0') return;
        ev.preventDefault();
        var s = readSettings(root);
        if (!s.hasPlayable) return;
        appendFrame(root, s, true);
      };

      root.addEventListener('click', root._fvOnClick);
      root.addEventListener('keydown', root._fvOnKeydown);

      var s = readSettings(root);
      if (shouldAutoload(s)) {
        appendFrame(root, s, false);
      }
    }

    disconnectedCallback() {
      var root = this;
      if (root._fvOnClick) {
        root.removeEventListener('click', root._fvOnClick);
        root._fvOnClick = null;
      }
      if (root._fvOnKeydown) {
        root.removeEventListener('keydown', root._fvOnKeydown);
        root._fvOnKeydown = null;
      }
      root.removeAttribute('data-fv-ready');
    }
  }

  customElements.define('featured-video', FeaturedVideoElement);
})();
